export default __webpack_public_path__ + "static/media/newSet3-1-min.2ee5394b.png";